import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'VGA Series',
      href: '/en/Motion_Detection/Alarm_FTP_Upload/VGA_Series/',
    },
    {
      text: '720p Series',
      href: '/en/Motion_Detection/Alarm_FTP_Upload/720p_Series/',
    },
    {
      text: '1080p Series',
      href: '/en/Motion_Detection/Alarm_FTP_Upload/',
    },
    {
      text: '◄ Motion Detection',
      href: '/en/Motion_Detection/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={6}
        aria-label="Alarm Upload / FTP Settings for 1080p Cameras"
      />
      <EuiSpacer />
    </Fragment>
  );
}